// @flow
export const domain = 'connection'



// WEBPACK FOOTER //
// ./src/services/connection/constants.js